import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../type';

export const adminSelector = (state: RootState) => state.admin;

export const isAdminSelector = createSelector(adminSelector, (state) => state);
